export default [
  {
    value: 'exchange',
    name: 'Echange',
    id: 1
  },
  {
    value: 'return',
    name: 'Retour',
    id: 2
  }
];
